export default class StatoContratto{
    Codice;
    Descrizione;

    constructor(){}
}